import React, { useContext } from 'react';
import { useFocusManager } from '@react-aria/focus';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { checkIfChildIsA, getTarget } from './NavbarHelpers.js';
import NavbarBadge from './NavbarBadge.js';
import { NavbarContext } from './NavbarContext.js';

/* eslint-disable max-len */
const NavbarMobileMenuItem = React.forwardRef(function menuItem(props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { item, location, onClick, linkWrapper, isOpen } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const focusManager = useFocusManager();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { setShowMobileMenu } = useContext(NavbarContext);
    const handleKeyDown = (e) => {
        if (!focusManager)
            return;
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                focusManager.focusNext({ wrap: true });
                break;
            case 'ArrowUp':
                e.preventDefault();
                focusManager.focusPrevious({ wrap: true });
                break;
            case 'End':
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case 'Home':
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    const handleClick = (e, item, isButton) => {
        if (isButton) {
            item.menuItems ? onClick && onClick(e) : item.onClick();
        }
        if (!item.menuItems)
            setShowMobileMenu(false);
    };
    if (item.header) {
        return React.createElement(React.Fragment, null, item.label);
    }
    return (React.createElement(React.Fragment, null, item.onClick || item.menuItems ? (React.createElement("button", { disabled: item.disabled, ref: ref, onKeyDown: (e) => handleKeyDown(e), className: `${item.url === location ||
            item.active ||
            item.activePathname === location ||
            (item.menuItems && item.menuItems.filter((item) => item.active).length > 0) ||
            (item.menuItems &&
                item.menuItems.filter((item) => item.activePathname && item.activePathname === location)
                    .length > 0) ||
            (item.menuItems && item.menuItems.filter((item) => item.url === location).length > 0)
            ? 'active'
            : ''}
                    helix-unified-nav__mobile-menu-dropdown-button
                 ${item.menuItems ? 'helix-unified-nav__mobile-menu-dropdown-toggle' : ''} ${item.badge && item.badge.label !== undefined && !item.badge.hidden
            ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
            : ''}`, onClick: (e) => handleClick(e, item, true) },
        React.createElement("span", { className: 'helix-unified-nav__mobile-menu-label' }, item.label),
        item.badge && item.badge.label !== undefined && !item.badge.hidden && (React.createElement(NavbarBadge, null, item.badge.label)),
        item.menuItems && React.createElement(NavbarHelixIcon, { iconName: !isOpen ? 'dropdown_closed' : 'dropdown_open' }))) : (React.createElement(React.Fragment, null, linkWrapper ? (React.createElement(React.Fragment, null, React.cloneElement(linkWrapper({
        item,
        props: {
            disabled: item.disabled,
            className: item.url === location || item.active || item.activePathname === location
                ? `active ${item.badge && item.badge.label !== undefined && !item.badge.hidden
                    ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                    : ''}`
                : `${item.badge && item.badge.label !== undefined && !item.badge.hidden
                    ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                    : ''}`,
            onClick: (e) => handleClick(e, item, false),
            onKeyDown: (e) => handleKeyDown(e)
        }
    }), {
        ref: ref,
        disabled: item.disabled,
        className: item.url === location || item.active || item.activePathname === location
            ? `active ${item.badge && item.badge.label !== undefined && !item.badge.hidden
                ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                : ''}`
            : `${item.badge && item.badge.label !== undefined && !item.badge.hidden
                ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                : ''}`,
        onKeyDown: (e) => handleKeyDown(e),
        onClick: (e) => handleClick(e, item, false),
        children: checkIfChildIsA(linkWrapper, menuItem) ? (React.cloneElement((_b = linkWrapper({
            item: menuItem,
            props: Object.assign(Object.assign({}, (_a = linkWrapper({
                item: item,
                props: {
                    disabled: item.disabled,
                    className: `
                                                            ${item.badge &&
                        item.badge.label !== undefined &&
                        !item.badge.hidden
                        ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                        : ''}
                                                                ${item.url === location ||
                        item.active ||
                        item.activePathname === location
                        ? 'helix-unified-nav__navigation-item active'
                        : 'helix-unified-nav__navigation-item'}`
                }
            })) === null || _a === void 0 ? void 0 : _a.props), { disabled: item.disabled, className: `
                                                    ${item.badge &&
                    item.badge.label !== undefined &&
                    !item.badge.hidden
                    ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                    : ''}
                                                        ${item.url === location ||
                    item.active ||
                    item.activePathname === location
                    ? 'helix-unified-nav__navigation-item active'
                    : 'helix-unified-nav__navigation-item'}` })
        })) === null || _b === void 0 ? void 0 : _b.props.children, {
            children: (React.createElement(React.Fragment, null, (_d = linkWrapper({
                item: item,
                props: Object.assign(Object.assign({}, (_c = linkWrapper({
                    item: item,
                    props: {
                        disabled: item.disabled,
                        className: `
                                                                            ${item.badge &&
                            item.badge.label !== undefined &&
                            !item.badge.hidden
                            ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                            : ''}
                                                                                ${item.url === location ||
                            item.active ||
                            item.activePathname === location
                            ? 'helix-unified-nav__navigation-item active'
                            : 'helix-unified-nav__navigation-item'}`
                    }
                })) === null || _c === void 0 ? void 0 : _c.props), { disabled: item.disabled, className: `
                                                                    ${item.badge &&
                        item.badge.label !== undefined &&
                        !item.badge.hidden
                        ? 'helix-unified-nav__mobile-menu-dropdown--with-badge'
                        : ''}
                                                                        ${item.url === location ||
                        item.active ||
                        item.activePathname === location
                        ? 'helix-unified-nav__navigation-item active'
                        : 'helix-unified-nav__navigation-item'}` })
            })) === null || _d === void 0 ? void 0 :
                _d.props.children.props.children,
                item.badge &&
                    item.badge.label !== undefined &&
                    !item.badge.hidden && (React.createElement(NavbarBadge, null, item.badge.label))))
        })) : (React.createElement(React.Fragment, null,
            ((_e = linkWrapper({
                item: item,
                props: {}
            })) === null || _e === void 0 ? void 0 : _e.props) &&
                ((_f = linkWrapper({
                    item: item,
                    props: {}
                })) === null || _f === void 0 ? void 0 : _f.props.children) &&
                ((_h = linkWrapper({
                    item: item,
                    props: Object.assign(Object.assign({}, (_g = linkWrapper({
                        item: item,
                        props: {
                            disabled: item.disabled,
                            className: item.url === location ||
                                item.active ||
                                item.activePathname === location
                                ? 'helix-unified-nav__navigation-item active'
                                : 'helix-unified-nav__navigation-item'
                        }
                    })) === null || _g === void 0 ? void 0 : _g.props), { disabled: item.disabled, className: item.url === location ||
                            item.active ||
                            item.activePathname === location
                            ? 'helix-unified-nav__navigation-item active'
                            : 'helix-unified-nav__navigation-item' })
                })) === null || _h === void 0 ? void 0 : _h.props.children),
            item.badge && item.badge.label !== undefined && !item.badge.hidden && (React.createElement(NavbarBadge, null, item.badge.label))))
    }))) : (React.createElement("a", Object.assign({ className: `${item.badge && item.badge.label !== undefined && !item.badge.hidden
            ? `helix-unified-nav__mobile-menu-dropdown--with-badge ${item.disabled ? 'disabled' : ''}`
            : ''}`, ref: ref, onKeyDown: (e) => handleKeyDown(e), href: item.url, onClick: (e) => {
            if (item.disabled) {
                e.preventDefault();
                return;
            }
            handleClick(e, item, false);
        } }, getTarget(item)),
        typeof item.label === 'function' ? item.label(item) : item.label,
        item.badge && item.badge.label !== undefined && !item.badge.hidden && (React.createElement(NavbarBadge, null, item.badge.label))))))));
});

export { NavbarMobileMenuItem as default };
//# sourceMappingURL=NavbarMobileMenuItem.js.map
